<script>
export default {
  name: "ElectionsDashboardCard"
}
</script>

<template>
<v-card width="100%">
  <v-card-title>Politische Akteure</v-card-title>
  <v-card-text class="commune-dashboard-min-height">
    <p>Steckbriefe, Kontaktdaten und weitere Informationen</p>
  </v-card-text>
  <v-card-actions>
    <v-btn text color="primary" tile block link to="/elections" class="font-weight-bold commune-dashboard-dotted-border commune-dashboard-card-btn">
      Zur Übersicht
      <v-icon right>mdi-arrow-right</v-icon>
    </v-btn>
  </v-card-actions>
</v-card>
</template>

<style scoped>

</style>